import * as React from 'react';

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const HeaderCard = React.forwardRef((props, ref) => {
    const { CARD_ID, IS_CHECKED_ALL, CARD_TITLE, handleSelectAll, handleInput, handleSearch } = props;
    
    const [checked, setCheckedH] = React.useState(IS_CHECKED_ALL);
    
    React.useImperativeHandle(ref, () => ({
      setChecked: (val) => {
        setCheckedH(val)
        }
    }));
    
    return (
      <ListSubheader component="div">
        <ListItemIcon>
          <Checkbox
            edge="start"
            style={
              CARD_ID !== "zone" && CARD_ID !== "clients"
                ? { padding: "0 2rem 0 2rem" }
                : {}
            }
            disableRipple
            checked={checked}
            id={CARD_ID}
            onClick={
              (e) => {
                setCheckedH(e.target.checked);
                handleSelectAll(e);
              }
            }
          />
        </ListItemIcon>
        <div
          className={
            CARD_ID !== "zone" && CARD_ID !== "clients"
              ? "exclutions__title-search"
              : "exclutions__depended-title-search"
          }
        >
          <ListItemText
            id={`exclutions__container-title-card-${CARD_ID}`}
            primary={CARD_TITLE}
            style={
              CARD_ID !== "zone" && CARD_ID !== "clients"
                ? { paddingLeft: "1.8rem" }
                : {}
            }
          />
          <div
            id={`exclutions__container-input-search-${CARD_ID}`}
            className="exclutions__container-input-search"
          >
            <input
              type="text"
              id={`exclutions__input-search-${CARD_ID}`}
              className="exclutions__input-search"
              onKeyUp={handleInput}
            />
            <ClearIcon
              className="exclutions__icon-clear"
              data-id={CARD_ID}
              onClick={(e) => handleSearch(false)}
            />
          </div>
        </div>
        <ListItemIcon
          id={`exclutions__container-button-search-${CARD_ID}`}
        >
          <SearchIcon
            data-id={CARD_ID}
            onClick={(e) => handleSearch(true)}
          />
        </ListItemIcon>
      </ListSubheader>
    
    );
  });
  
  
export default HeaderCard;